var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-6 text-center text--secondary"},[_c('v-img',{staticClass:"ml-auto mr-auto",attrs:{"src":require('@/assets/images/img_empty_data.png'),"max-width":"300"}}),_c('p',{staticClass:"py-8 title font-weight-bold"},[_vm._v(_vm._s(_vm.contentEmpty))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }